/**
 * @typedef {ReturnType <typeof import('widgets/wishlist/WishlistMgr').default>} WishlistMgr
 */

/**
 * @param {WishlistMgr} WishlistMgr widget for extending
 * @returns {typeof HarmonyWishlistMgr} HarmonyWishlistMgr widget
 */
export default function (WishlistMgr) {
    class HarmonyWishlistMgr extends WishlistMgr {
        init() {
            super.init();
            this.eventBus().on('wishlist.reRenderTemplate', 'reRenderTemplate');
        }

        /**
         * @description Render to template wishlist
         * @param {object} wishlistModel Wishlist Model object to render
         * @returns {Promise<any>}
         */
        reRenderWishlist(wishlistModel) {
            return super.reRenderWishlist(wishlistModel).then(() => {
                if (wishlistModel?.totalCount <= 0) {
                    this.eventBus().emit('wishlist.empty');
                }
            });
        }

        confirmedRemoveProductFromWishlist() {
            super.confirmedRemoveProductFromWishlist();

            if (this.productToRemove) {
                this.eventBus().emit('product.removed.from.wishlist', this.productToRemove.data('analytics'));
                this.ref('self').get().querySelector('.b-product_tile-image').focus();
            }
        }

        /**
         * @description Rerender templates for wishlist components
         * Requires due to we use one template for whole wishlist
         * @param {object} params - params
         */
        reRenderTemplate(params) {
            this.render(params.templateRefId, params.data, params.element);
        }
    }

    return HarmonyWishlistMgr;
}
